export default "__VITE_ASSET__DjCpTrD___"